import Cargos from '@/models/Cargos'

export default [
  {
    path: '/administrativo/produtos',
    name: 'rota-produtos',
    autenticado: true,
    cargo: [Cargos.ADMINISTRADOR],
    titulo: 'Produtos',
    layout: 'LayoutBarraLateral',
    menu: {
      label: 'Produtos',
      icon: 'boxes',
    },
    component: () => import(/* webpackChunkName: "produtos" */ '../views/produtos/Produtos.vue'),
  },
  {
    path: '/administrativo/produtos/cadastro',
    name: 'rota-produtos-cadastro',
    autenticado: true,
    cargo: [Cargos.ADMINISTRADOR],
    titulo: 'Cadastro de produtos',
    layout: 'LayoutBarraLateral',
    component: () => import(/* webpackChunkName: "produtos" */ '../views/produtos/cadastro/ProdutosCadastro.vue'),
  },
  {
    path: '/administrativo/produtos/:id',
    name: 'rota-produtos-alteracao',
    autenticado: true,
    cargo: [Cargos.ADMINISTRADOR],
    titulo: 'Alteração de produtos',
    layout: 'LayoutBarraLateral',
    component: () => import(/* webpackChunkName: "produtos" */ '../views/produtos/cadastro/ProdutosCadastro.vue'),
  },
]
